import { Container, Divider, FormControlLabel, Paper, Stack, Switch, Tab, Typography } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useState } from 'react';
import Banners from './components/Banners';
import Featureds from './components/Featureds';
import MenuCarousel from './components/MenuCarousel';
export default function App() {
    const [tab, setTag] = useState('banners');
    const [includeClubItems, setIncludeClubItems] = useState(false);

    return (
        <Container maxWidth="xl">
            <Stack pb={2} direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ sm: 'center' }} gap={1}>
                <Typography variant="h2">Aplicativo</Typography>
                <FormControlLabel
                    control={
                        <Switch
                            checked={includeClubItems}
                            onChange={(_, checked) => setIncludeClubItems(checked)}
                            color="primary"
                        />
                    }
                    label={includeClubItems ? 'Todos (admin + clubes)' : 'Apenas global (admin)'}
                />
            </Stack>

            <Paper>
                <TabContext value={tab}>
                    <TabList onChange={(_, value) => setTag(value)}>
                        <Tab label="Banners" value="banners" />
                        <Tab label="Menu/Botões Personalizados" value="menu-carrossel" />
                        <Tab label="Feed Principal" value="feed-principal" />
                    </TabList>
                    <Divider />
                    <TabPanel value="banners" sx={{ p: 0 }}>
                        <Banners includeClubItems={includeClubItems} />
                    </TabPanel>
                    <TabPanel value="menu-carrossel" sx={{ p: 0 }}>
                        <MenuCarousel includeClubItems={includeClubItems} />
                    </TabPanel>
                    <TabPanel value="feed-principal" sx={{ p: 0 }}>
                        <Featureds includeClubItems={includeClubItems} />
                    </TabPanel>
                </TabContext>
            </Paper>
        </Container>
    );
}
